(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sticker-slap reveals
  var els = document.querySelectorAll('[data-mynd-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // One-tap add by size
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mynd-add]');
    if (!chip || chip.disabled) return;
    e.preventDefault();
    var label = chip.textContent;
    chip.disabled = true;
    chip.classList.add('is-loading');
    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +chip.getAttribute('data-mynd-add'), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function (added) {
      chip.classList.remove('is-loading');
      chip.classList.add('is-added');
      chip.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('mynd:added', { detail: added }));
      if (window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') theme.ajaxCart.update();
      if (window.theme && theme.RightDrawer && typeof theme.RightDrawer.open === 'function') theme.RightDrawer.open();
      setTimeout(function () {
        chip.textContent = label;
        chip.classList.remove('is-added');
        chip.disabled = false;
      }, 1800);
    }).catch(function () {
      chip.classList.remove('is-loading');
      chip.textContent = 'Sold out';
    });
  });

  // Size sheet: one clean picker instead of a wall of size buttons on every card
  var sheet = null;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function closeSheet() { if (sheet) sheet.hidden = true; }
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'mqs-sheet';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="mqs-sheet__backdrop" data-sheet-close></div>' +
      '<div class="mqs-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="MqsSheetTitle">' +
      '<button type="button" class="mqs-sheet__close" data-sheet-close aria-label="Close">&times;</button>' +
      '<p class="mqs-sheet__title" id="MqsSheetTitle"></p><p class="mqs-sheet__price"></p>' +
      '<div class="mqs-sheet__body"></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    document.addEventListener('mynd:added', function () { setTimeout(closeSheet, 450); });
    return sheet;
  }
  function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }
  function openSheet(d) {
    ensureSheet();
    var opts = d.options || [];
    // Only options with a real choice count (a bundled chain has one value: skip it)
    var live = opts.map(function (o, i) { return i; }).filter(function (i) {
      return uniq(d.variants.map(function (v) { return v.o[i]; })).length > 1;
    });
    if (!live.length) live = [0];
    var sizeIdx = live[0];
    live.forEach(function (i) { if (/size|waist|length/i.test(opts[i]) && !/size|waist|length/i.test(opts[sizeIdx])) sizeIdx = i; });
    var otherIdx = live.length === 2 ? (live[0] === sizeIdx ? live[1] : live[0]) : -1;
    var flat = live.length > 2;
    var others = otherIdx >= 0 ? uniq(d.variants.map(function (v) { return v.o[otherIdx]; })) : [];
    var sel = others.filter(function (val) { return d.variants.some(function (v) { return v.o[otherIdx] === val && v.a; }); })[0] || others[0];
    sheet.querySelector('.mqs-sheet__title').textContent = d.title;
    var cents = +d.price || 0, dollars = (cents / 100).toFixed(2);
    sheet.querySelector('.mqs-sheet__price').textContent = '$' + (dollars.slice(-3) === '.00' ? dollars.slice(0, -3) : dollars);
    var body = sheet.querySelector('.mqs-sheet__body');
    function render() {
      var html = '';
      if (otherIdx >= 0) {
        html += '<p class="mqs-sheet__label">' + esc(opts[otherIdx]) + '</p><div class="mqs-sheet__pills">' +
          others.map(function (val) {
            var any = d.variants.some(function (v) { return v.o[otherIdx] === val && v.a; });
            return '<button type="button" class="mqs-sheet__pill' + (val === sel ? ' is-on' : '') + (any ? '' : ' is-out') + '" data-pill="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('') + '</div>';
      }
      var list = flat ? d.variants.map(function (v) { return { label: live.map(function (i) { return v.o[i]; }).join(' / '), v: v }; }) :
        uniq(d.variants.map(function (v) { return v.o[sizeIdx]; })).map(function (size) {
          var v = d.variants.filter(function (x) { return x.o[sizeIdx] === size && (otherIdx < 0 || x.o[otherIdx] === sel); })[0];
          return v ? { label: size, v: v } : null;
        }).filter(Boolean);
      html += '<p class="mqs-sheet__label">' + esc(flat ? 'Option' : (opts[sizeIdx] || 'Size')) + '</p><div class="mqs-sheet__grid' + (flat ? ' is-flat' : '') + '">' +
        list.map(function (it) {
          return it.v.a ? '<button type="button" class="mqs-sheet__size" data-mynd-add="' + it.v.id + '">' + esc(it.label) + '</button>' :
            '<button type="button" class="mqs-sheet__size is-out" disabled aria-label="' + esc(it.label) + ', sold out">' + esc(it.label) + '</button>';
        }).join('') + '</div>';
      if (list.some(function (it) { return !it.v.a; })) html += '<p class="mqs-sheet__legend"><span></span>Sold out</p>';
      body.innerHTML = html;
      body.querySelectorAll('[data-pill]').forEach(function (p) {
        p.addEventListener('click', function () { sel = p.getAttribute('data-pill'); render(); });
      });
    }
    render();
    sheet.hidden = false;
    var first = sheet.querySelector('.mqs-sheet__size:not([disabled])') || sheet.querySelector('.mqs-sheet__close');
    if (first) first.focus();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mqs-open]');
    if (!btn) return;
    e.preventDefault();
    var json = btn.parentNode.querySelector('[data-mqs-json]');
    if (!json) return;
    try { openSheet(JSON.parse(json.textContent)); } catch (err) {}
  });

  // Arrows for the sideways-scrolling rows (Shop the drop, Bundle up)
  document.querySelectorAll('.mqs__rail, .mbr__rail').forEach(function (rail) {
    var wrap = document.createElement('div');
    wrap.className = 'mrail';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);
    function mk(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mrail__btn mrail__btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Scroll back' : 'Scroll forward');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"/></svg>';
      b.addEventListener('click', function () {
        var card = rail.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
        if (rail.clientWidth > step * 1.8) step = Math.floor(rail.clientWidth / step) * step;
        rail.scrollBy({ left: dir === 'prev' ? -step : step, behavior: reduce ? 'auto' : 'smooth' });
      });
      wrap.appendChild(b);
      return b;
    }
    var prev = mk('prev'), next = mk('next');
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 4;
      prev.classList.toggle('is-off', rail.scrollLeft <= 4);
      next.classList.toggle('is-off', rail.scrollLeft >= max);
      wrap.classList.toggle('is-static', max <= 0);
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  });

  // Mobile "Shop the drop" bar hides once the shop rail is on screen or passed
  var bar = document.querySelector('[data-mynd-shopbar]');
  var target = document.getElementById('MyndQuickShop');
  if (bar && target && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      bar.classList.toggle('is-hidden', en.isIntersecting || en.boundingClientRect.top < 0);
    }).observe(target);
  } else if (bar) {
    bar.classList.add('is-hidden');
  }
})();
